/**
 * 处理 LOVE_ROOM_VIDEO_POP 消息（视频弹窗）
 * 当服务端推送此消息时，引导用户发起视频通话
 */

import { showVideoTopPop, isVideoTopPopShow } from '@/components/VideoTopPop'
import { LIVE_ROOM_COME_FROM } from '@/common/constants'
import { useGlobalStore } from '@/stores/global'
import { matchPopReport } from '@/api/video'
import { useVideoCallStore } from '@/stores/videoCall'
import router from '@/router'

const matchPopNotExposeReport = async (target_id, pop_id) => {
  await matchPopReport({
    target_id,
    pop_id,
    scene: matchPopReport.SCENE.DEFAULT,
    status: matchPopReport.STATUS.NOT_EXPOSE,
  })
}

/**
 * 处理 LOVE_ROOM_VIDEO_POP 消息
 * @param {Object} event - EventBus 事件对象
 * @param {Object[]} event.data - IMManager 派发的消息数组
 */
export async function handleLoveRoomVideoPop(event) {
  console.log('[handleLoveRoomVideoPop] event:', event)
  const { data: messages } = event
  if (!Array.isArray(messages) || messages.length === 0) return

  const message = messages[0] || {}
  const { msg_content, timestamp } = message
  const { love_invite_member } = msg_content || {}
  const pop_id = msg_content?.pop_id || message.pop_id

  if (!love_invite_member) {
    console.warn('[handleLoveRoomVideoPop] missing love_invite_member data')
    return
  }

  // 提取用户信息
  const {
    id: targetId,
    member_id: targetMemberId,
    avatar,
    nickname,
    national_flag: nationFlag,
    nation,
  } = love_invite_member

  // 获取必要的 stores
  const globalStore = useGlobalStore()
  const videoCallStore = useVideoCallStore()

  // 从 globalStore 获取配置
  const { video_pop_delay, video_pop_show_duration } = globalStore.staticConfig?.video_pop_config || {}
  // const video_pop_page_limit = globalStore.staticConfig?.video_pop_page_limit || []

  // ========== 显示限制条件检查 ==========

  // 1. 检查 APP 是否在前台
  if (!globalStore.isDocumentVisible) {
    matchPopNotExposeReport(targetId, pop_id)
    return
  }

  // 2. 检查是否在 VIP/DIAMOND 商品页
  const currentRouteName = router.currentRoute.value.name
  if (currentRouteName === 'diamond' || currentRouteName === 'vip') {
    matchPopNotExposeReport(targetId, pop_id)
    return
  }

  // 3. 检查是否在首页或允许的页面
  // const isHomePage = currentRouteName === 'Home'
  // const isAllowedPage = video_pop_page_limit.includes(currentRouteName)
  // if (!isHomePage && !isAllowedPage) {
  //   console.log('[handleLoveRoomVideoPop] Not in home or allowed page, not show')
  //   await matchPopReport({
  //     target_id: love_invite_member?.id,
  //     pop_id,
  //     scene: matchPopReport.SCENE.DEFAULT,
  //     status: matchPopReport.STATUS.NOT_EXPOSE,
  //   })
  //   return
  // }

  // 4. 检查是否空闲状态
  if (!videoCallStore.isIdle) {
    matchPopNotExposeReport(targetId, pop_id)
    return
  }

  // 5. 检查 VideoTopPop 是否已经显示
  if (isVideoTopPopShow()) {
    matchPopNotExposeReport(targetId, pop_id)
    return
  }

  // 6. 时间戳校验
  if (timestamp && video_pop_delay) {
    const currentTime = Date.now()
    const diff = Math.abs(currentTime - timestamp)
    const delayMs = video_pop_delay * 1000 // 秒转毫秒

    if (diff > delayMs) {
      matchPopNotExposeReport(targetId, pop_id)
      return
    }
  }

  // 展示顶部横幅通知 - 组件内部会处理视频通话逻辑
  showVideoTopPop({
    autoClose: video_pop_show_duration,

    // 目标用户信息（包含显示信息和通话信息）
    targetMember: {
      id: targetId,
      member_id: targetMemberId,
      avatar,
      nickname,
      nation_flag: nationFlag,
      nation,
    },

    // 通话来源和弹窗ID
    comeFrom: LIVE_ROOM_COME_FROM.VIDEO_POP,
    popId: pop_id,
  })
}
